import { SwipeToDelete } from "@/shared/Components";
import { CardSeparator } from "@/shared/Components/CardSeparator";
import type { FC } from "react";
import type { NotesListProps } from "../../model";
import { NotesListCard } from "../NotesListCard";
import styles from "./styles.module.scss";

export const NotesListV2: FC<NotesListProps> = ({
  cardsData,
  onClickCardDelete,
  onClickCardEdit,
  onChangeCardStatus,
  onLongPress,
  selectedNotesIds,
  onAvatarClick,
  setSwipedNote,
  swipedNote,
}) => {
  return (
    <div className={styles["notes-list-root"]}>
      {cardsData.map((cardData) => (
        <SwipeToDelete
          onClickEdit={() => onClickCardEdit(cardData)}
          onDelete={() => onClickCardDelete(cardData)}
          setSwipedId={setSwipedNote}
          currentId={cardData.id}
          swipedId={swipedNote}
          key={cardData.id}
        >
          <NotesListCard
            onAvatarClick={onAvatarClick}
            onLongPress={onLongPress}
            selectedNotesIds={selectedNotesIds}
            onStatusChange={onChangeCardStatus}
            cardData={cardData}
          />
          <CardSeparator />
        </SwipeToDelete>
      ))}
    </div>
  );
};
